import { useMemo, useState, useRef, useEffect } from 'react'
import { ChevronDown, ChevronUp } from "lucide-react"
import { useTranslation } from "react-i18next"

export default function LanguageSelect() {
    const { i18n } = useTranslation()

    const currentLang = useMemo(() => i18n.language, [ i18n.language ])

    const availableLanguages = useMemo(() => {
        return Object.keys(i18n.store.data).filter((lang) => lang !== "dev" && lang != currentLang)
    }, [ currentLang, i18n.store.data ])

    const [isActive, setActive] = useState(false)

    const ref = useRef()

    const setLang = (lang) => {
        i18n.changeLanguage(lang)
        setActive(false)
    }

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (!ref?.current?.contains(event.target)) {
          setActive(false)
        }
      }

      document.addEventListener("mousedown", handleClickOutside)
    }, [ref])

    return (
        <div ref={ref}>
            <div className={`flex justify-center align-center relative text-nunito text-[24px] -mt-[2px] font-semibold uppercase cursor-pointer hover:text-slate-400 transition`} onClick={() => setActive(!isActive)} id="lang-selected">
                {currentLang}
                {isActive
                    ? <ChevronUp className="mt-1" />
                    : <ChevronDown className="mt-1" />
                }
            </div>
            {isActive && (
                <div id="lang-dropdown" className={`relative w-full transition`}>
                    <div className={`w-full rounded border z-[9999] border-slate-100 cursor-pointer absolute top-0 bg-white ${isActive}`}>
                        {availableLanguages.map((lang) => (
                            <div className="text-lg bg-none border border-slate-100 p-1 text-center text-slate-400 uppercase transition hover:bg-slate-100 hover:text-slate-300" key={lang} value={lang} onClick={() => setLang(lang)}>{lang}</div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}